import { render, staticRenderFns } from "./partnerRecordList.vue?vue&type=template&id=44b2c7e9&scoped=true"
import script from "./partnerRecordList.vue?vue&type=script&lang=js"
export * from "./partnerRecordList.vue?vue&type=script&lang=js"
import style0 from "./partnerRecordList.vue?vue&type=style&index=0&id=44b2c7e9&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44b2c7e9",
  null
  
)

export default component.exports